
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/AccessProfile/List', formData);
}

const AddEdit = async (formData: FormData) => {
    return AxiosHelper.post('/AccessProfile/AddEdit', formData);
}

const Remove = async (formData: FormData) => {
    return AxiosHelper.post('/AccessProfile/Remove', formData);
}


const AccessProfileService = {
    List,
    AddEdit,
    Remove
}

export default AccessProfileService;